import React from "react";

export default function (props){
    return <svg style={props?.style ?? {}} width="15" height="10" viewBox="0 0 12 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.469727 2.03022L1.53039 0.969557L6.00006 5.43923L10.4697 0.969557L11.5304 2.03022L6.00006 7.56055L0.469727 2.03022Z" fill="currentColor"/>
    </svg>

}